import { ensureGuestBetterAuthSession } from '~~/layers/base/utils/ensureGuestBetterAuthSession'

/**
 * Ensures a guest has an anonymous Better Auth session on first app load.
 *
 * `useBetterAuth` no longer uses a one-shot session watcher (that pattern could not re-run after
 * logout). Initial anonymous sign-in lives here; **post-logout** anonymous is restored explicitly
 * via `useBetterAuthLogout` (see TK-9957).
 *
 * Offline cold start: skip `getSession` / anonymous entirely so WebKit does not log failed
 * auth resource loads. Guest UI boots; session is established once connectivity returns.
 *
 * Ecommerce designer skips Better Auth during the TK-13530 injunction (until the purchase flow
 * uses Better Auth); see `better-auth-ecommerce-designer-resume.client.ts`.
 */
export default defineNuxtPlugin({
    name: 'better-auth-initial-anonymous',
    async setup() {
        const datadog = useDatadog()
        try {
            await ensureGuestBetterAuthSession(datadog)
        } catch (error) {
            const err = error instanceof Error ? error : new Error(String(error))
            datadog.logError(err, {
                feature: 'better-auth',
                action: 'signIn.anonymous',
                phase: 'initial-plugin',
            })
        }
    },
})
